// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_qx-0";
export var animationContainer = "_qx-1";
export var itemPrice = "_qx-a";
export var itemizedContent = "_qx-9";
export var itemizedHeader = "_qx-7";
export var itemizedRow = "_qx-8";
export var itemizedSection = "_qx-6";
export var modalContent = "_qx-2";
export var orderName = "_qx-3";
export var refundOption = "_qx-4";
export var refundOptionsContainer = "_qx-5";
export var shippingLabel = "_qx-b";
export var totalRow = "_qx-c";